module.exports = __webpack_public_path__ + "img/A12b_19950037-009.1c4c57f0.jpg";